import { ChainSyncer } from './lib/chain-syncer';
import { InMemoryAdapter } from './lib/in-memory-adapter';

export default ChainSyncer;
export { ChainSyncer, InMemoryAdapter };

export * from './types';